/**
 * Membership status enums and shared interfaces.
 */

/** Database status — only 2 values are persisted. */
export const MEMBERSHIP_DB_STATUS = {
  VALID: 'valid',
  CANCELLED: 'cancelled',
} as const;

export type MembershipDbStatus = typeof MEMBERSHIP_DB_STATUS[keyof typeof MEMBERSHIP_DB_STATUS];

/** Display status — calculated from DB status + dates for UI. */
export const MEMBERSHIP_DISPLAY_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  UPCOMING: 'upcoming',
  CANCELLED: 'cancelled',
} as const;

export type MembershipDisplayStatus = typeof MEMBERSHIP_DISPLAY_STATUS[keyof typeof MEMBERSHIP_DISPLAY_STATUS];

/** Legacy aliases — kept so existing imports keep working. */
export const MEMBERSHIP_STATUS = MEMBERSHIP_DISPLAY_STATUS;
export type MembershipStatus = MembershipDisplayStatus;

export interface MembershipDateRange {
  start_date: string | null;
  end_date: string | null;
  status?: MembershipDbStatus;
  cancelled_at?: string | null;
}
